import React, { useState, useEffect } from 'react';
import FadeInAnimation from "../Common/FadeInAnimation";
import { Player } from '@lottiefiles/react-lottie-player';
import { useTranslations } from '../../locales/useTranslations';

const AppDevelopmentEigenschaften = () => {
    const { t } = useTranslations();
    const [autoplay, setAutoplay] = useState(null);
    const [isReady, setIsReady] = useState(false);

    useEffect(() => {
        // Prüfe die Bildschirmbreite für mobile Geräte (< 768px)
        const checkIsMobile = () => {
            const width = window.innerWidth;
            const isMobile = width < 768;
            return isMobile;
        };

        // Initiale Prüfung
        setAutoplay(checkIsMobile());
        setIsReady(true);

        // Event-Listener für Fenstergrößenänderungen
        const handleResize = () => {
            setAutoplay(checkIsMobile());
        };

        window.addEventListener('resize', handleResize);

        // Cleanup
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    // Warte, bis die Prüfung abgeschlossen ist, bevor die Player gerendert werden
    if (!isReady) {
        return (
            <div className="features-card-section pt-70 pb-70 bg-f8fbfa">
                <div className="container">
                    <div className="row">
                        {/* Placeholder während der Prüfung */}
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="features-card-section pt-70 pb-70 bg-f8fbfa">
            <div className="container">
                <div className="row">
                    <div className="col-lg-4 col-sm-12">
                        <FadeInAnimation direction="up" delay={50}>
                            <div className="single-features-card tx-center">
                                <Player
                                    {...(autoplay && { autoplay: true })}
                                    loop
                                    hover
                                    src="/images/lottie/app-responsive.json"
                                    style={{ height: '300px' }}
                                />
                                <h3>{t('appDevelopment_features_responsive_title')}</h3>
                                <p>{t('appDevelopment_features_responsive_description')}</p>
                            </div>
                        </FadeInAnimation>
                    </div>

                    <div className="col-lg-4 col-sm-12">
                        <FadeInAnimation direction="up" delay={100}>
                            <div className="single-features-card tx-center">
                                <Player
                                    {...(autoplay && { autoplay: true })}
                                    loop
                                    hover
                                    src="/images/lottie/target.json"
                                    style={{ height: '300px' }}
                                />
                                <h3>{t('appDevelopment_features_targeted_title')}</h3>
                                <p>{t('appDevelopment_features_targeted_description')}</p>
                            </div>
                        </FadeInAnimation>
                    </div>

                    <div className="col-lg-4 col-sm-12">
                        <FadeInAnimation direction="up" delay={150}>
                            <div className="single-features-card tx-center">
                                <Player
                                    {...(autoplay && { autoplay: true })}
                                    loop
                                    hover
                                    src="/images/lottie/app-design.json"
                                    style={{ height: '300px' }}
                                />
                                <h3>{t('appDevelopment_features_design_title')}</h3>
                                <p>{t('appDevelopment_features_design_description')}</p>
                            </div>
                        </FadeInAnimation>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AppDevelopmentEigenschaften;